module.exports = __webpack_public_path__ + "images/misc.2823679b5587bd73bf68e162b0bb57b3.png";